import React from "react";
export const CalendarViewIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8 0.600098H2.6C1.71634 0.600098 1 1.31644 1 2.2001V13.4001C1 14.2838 1.71634 15.0001 2.6 15.0001H13.8C14.6837 15.0001 15.4 14.2838 15.4 13.4001V2.2001C15.4 1.31644 14.6837 0.600098 13.8 0.600098Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 5.3999H15.4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
